import React from 'react';
import ValidityHelper from '../../../../Helpers/ValidityHelper';
import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import ClientLineItemService from '../../../../Services/ClientLineItemService';
import ClientInvoiceLineItemModify from '../../../../Domain/ClientInvoiceLineItemModify';
import selectHelper from '../../../../Helpers/selectHelper';

export default class CreateLineItemWindowDescription extends React.Component {
  static titleForCreate = 'Create Line Item';
  static titleForEdit = 'Edit Line Item';
  static itemType = ClientInvoiceLineItemModify;
  static serviceFunction = (edited) => ClientLineItemService.CreateLineItem(edited);

  getSelected() {}

  getSearchParameters() {}

  getAllItemInTheSearchAreSelected() {}

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'ClCiId',
          label: 'Client Invoice',
          className: 'col-4',
          type: InputTypesEnum.TextReadOnly,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'ClTotal',
          label: 'Client Fee',
          className: 'col-4',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: CreateLineItemWindowDescription.ForRequiredClientFee,
          disabled: (item) => item.IsInvoiceFinalized === true,
        },
        {
          fieldName: (item) => CreateLineItemWindowDescription.getCurrency(item),
          label: 'Currency',
          className: 'col-4',
          type: InputTypesEnum.CurrencySelect,
          validityChecker: ValidityHelper.AlwaysFlawless,
          showFilterAt: 500,
          disabled: (item) => item.IsInvoiceFinalized === true,
        },
        // The two type fields take half a row each so their labels are not truncated. Filling row
        // two also pushes 'Item Tied To' onto the next row, at its left edge.
        {
          fieldName: 'ClLliid',
          label: 'Type',
          className: 'col-12',
          type: InputTypesEnum.ClientLineTypeLookupItemSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
          disabled: (item) => item.IsInvoiceFinalized === true,
          // Changing the Type re-seeds the internal type with the same value. It is a copy on
          // change, not a mirror: the user is free to pick a different internal type afterwards
          // and it stays until Type is changed again.
          onFieldChange: CreateLineItemWindowDescription.copyTypeToInternalType,
        },
        {
          fieldName: 'InternalLineItemTypeLookupValue',
          label: 'Internal Type',
          className: 'col-12',
          type: InputTypesEnum.ClientLineTypeLookupItemSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        // Row three: 'Item Tied To' next to whichever of Project / Service it selected - they are
        // mutually exclusive, so exactly one of them is ever visible and the row holds two fields.
        {
          fieldName: 'TiedToType',
          label: 'Item Tied To:',
          className: 'col-6',
          type: InputTypesEnum.Select,
          selectvalues: CreateLineItemWindowDescription.getTiedToOptions(),
          validityChecker: CreateLineItemWindowDescription.validateTiedToType,
          disabled: (item) => item.IsInvoiceFinalized === true,
        },
        {
          fieldName: 'ClCfId',
          label: 'Project',
          className: 'col-6',
          type: InputTypesEnum.ActiveClientFeeSelect,
          idFilter: 'CcId',
          validityChecker: CreateLineItemWindowDescription.validateProjectSelect,
          hide: (item) => item.TiedToType !== 'Project',
          disabled: (item) => item.IsInvoiceFinalized === true,
        },
        {
          fieldName: 'ClServiceId',
          label: 'Service',
          className: 'col-6',
          type: InputTypesEnum.ActiveServiceSelect,
          idFilter: 'CcId',
          validityChecker: CreateLineItemWindowDescription.validateServiceSelect,
          hide: (item) => item.TiedToType !== 'Service',
          disabled: (item) => item.IsInvoiceFinalized === true,
        },
        //Only uncomment with Finance approval, this will affect the Commission process if reimplemented
        // {
        //   fieldName: 'ClOpportunityId',
        //   label: 'Opportunity',
        //   className: 'col-6',
        //   type: InputTypesEnum.ProjectOpportunitySelect,
        //   idFilterArray: [
        //     { filterName: 'ClientId', valueName: 'CcId' },
        //     { filterName: 'CfStartDate', value: dateTimeHelper.toYYYYsMMsDD(new Date()) },
        //   ],
        //   validityChecker: CreateLineItemWindowDescription.validateOpportunitySelect,
        //   hide: (item) => item.TiedToType !== 'Opportunity',
        // },
        {
          fieldName: 'ClDesc',
          label: 'Description',
          className: 'col-12',
          type: InputTypesEnum.TextBox,
          validityChecker: CreateLineItemWindowDescription.forDescriptionField,
          disabled: (item) => item.IsInvoiceFinalized === true,
        },
      ],
    },
  ];

  // Mutating the edited item is how the wizard's onFieldChange hook reaches a field other than
  // the one that was edited; returning nothing leaves Type itself as the user set it.
  static copyTypeToInternalType(item) {
    item.InternalLineItemTypeLookupValue = item.ClLliid;
  }

  static ForRequiredClientFee(e, item) {
    if (item.ClTotal && item.ClTotal >= 0.01) return '';
    return 'Number must be greater than or equal to 0.01!';
  }

  static getCurrency(item) {
    return item.CurrencyId;
  }

  static getTiedToOptions() {
    //Only uncomment with Finance approval, this will affect the Commission process if reimplemented
    return selectHelper.generateSelectValues(['', 'Project', 'Service' /*, 'Opportunity'*/]);
  }

  static validateTiedToType(e, item) {
    if (item.ClOpportunityId && !(item.ClCfId || item.ClServiceId)) {
      return 'You must select a Project or Service!';
    }
    if (item.ClCfId || item.ClServiceId /*|| item.ClOpportunityId*/) {
      return '';
    }
    return ValidityHelper.forRequiredSelectField(e, item);
  }

  static validateProjectSelect(e, item) {
    if (item.TiedToType === 'Project') {
      return ValidityHelper.forRequiredSelectField(e, item);
    }
    return '';
  }

  static validateServiceSelect(e, item) {
    if (item.TiedToType === 'Service') {
      return ValidityHelper.forRequiredSelectField(e, item);
    }
    return '';
  }

  //Only uncomment with Finance approval, this will affect the Commission process if reimplemented
  // static validateOpportunitySelect(e, item) {
  //   if (item.TiedToType === 'Opportunity') {
  //     return ValidityHelper.forRequiredSelectField(e, item);
  //   }
  //   return '';
  // }

  static forDescriptionField(e, item) {
    if (item.ClDesc && item.ClDesc.length > 200) {
      return 'Description must be less than 200 characters!';
    }
    return ValidityHelper.forRequiredTextField(e, item);
  }
}
